import React from 'react';
import { GenericFormModal } from './GenericFormModal';
import { ExhibitionFormFields } from '../forms/ExhibitionFormFields';

export function ExhibitionFormModal({ 
  isOpen, 
  onClose, 
  exhibition,
  onSubmit
}) {
  const [localFormData, setLocalFormData] = React.useState(exhibition || {
    name: '',
    locations: '',
    start_date: '',
    end_date: ''
  });

  // Update localFormData when exhibition prop changes
  React.useEffect(() => {
    if (exhibition) {
      setLocalFormData(exhibition);
    } else {
      setLocalFormData({
        name: '',
        locations: '',
        start_date: '',
        end_date: ''
      });
    }
  }, [exhibition, isOpen]);

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setLocalFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onSubmit(e, localFormData);
      onClose();
    } catch (error) {
      console.error('ExhibitionFormModal submit error:', error);
      // Modal bleibt offen bei Fehler
    }
  };

  return (
    <GenericFormModal 
      isOpen={isOpen} 
      onClose={onClose}
      title={exhibition ? 'Ausstellung bearbeiten' : 'Neue Ausstellung'}
      size="2xl"
    >
      <ExhibitionFormFields
        formData={localFormData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isEdit={!!exhibition}
      />
    </GenericFormModal>
  );
}